const logtoInjectionKey = '@logto/vue';
const contextInjectionKey = '@logto/vue:context';

export { contextInjectionKey, logtoInjectionKey };
